// extracted by mini-css-extract-plugin
export default {"reset":"IconButton_reset__0hfol"};